import { z } from "zod";
import { useForm, zodResolver } from "@mantine/form";
import {
  NumberInput,
  TextInput,
  Button,
  Box,
  Group,
  Center,
  BackgroundImage,
  Image,
  Title,
  Text,
  LoadingOverlay,
} from "@mantine/core";
import { api } from "../services/api";
import { showNotification } from "@mantine/notifications";
import { useState } from "react";
import { User } from "../App";

const schema = z.object({
  username: z.string().min(2, { message: "姓名或者昵称至少需要有两个字符" }),
  password: z.string().min(3, { message: "无效验证码" }),
});

interface Props {
  setUser: (user: User | ((prev: User) => User)) => void;
  setIsLogin: (isLogin: boolean) => void;
  setChatType: (chatType: string) => void;
}

export interface LoginFormValues {
  username: string;
  password: string;
}

function Login({ setIsLogin, setUser, setChatType }: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const form = useForm({
    validate: zodResolver(schema),
    initialValues: {
      username: "",
      password: String(new Date().getFullYear()),
    },
  });

  const handleSubmit = async (values: LoginFormValues) => {
    //console.log("values", values);
    setIsSubmitting(true);
    try {
      const response = await api.post("login", values);
      console.log("response", response);
      setChatType(response.data.chatType);
      setUser((prev) => ({ ...prev, ...values }));
      setIsLogin(true);
      window.sessionStorage.setItem("chatType", response.data.chatType);
      window.sessionStorage.setItem("login", String(true));
    } catch (error) {
      //console.log(error.response?.data?.message || error.message);
      showNotification({
        title: "无效验证码",
        message: "",
        color: "red",
      });
    }
    setIsSubmitting(false);
  };

  //

  return (
    <Box>
      <LoadingOverlay
        visible={isSubmitting}
        overlayBlur={1}
        overlayOpacity={0.3}
      />
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box mt='10rem'>
          {/* <Image
                width={80}
                height={80}
                radius='md'
                src='logo512.png'
                alt="Let's Chat"
              /> */}
          <Title
            order={1}
            // color='teal'
            italic
            variant='gradient'
            gradient={{ from: "indigo", to: "cyan", deg: 105 }}
          >
            Let's Chat
          </Title>
        </Box>
        <Box
          px='3rem'
          py='4rem'
          sx={{
            width: "80%",
            //boxShadow: "0 0 1rem 0 rgba(0, 0, 0, .2)",
            borderRadius: "2rem",
            backgroundColor: "rgba(255, 255, 255, .15)",
            backdropFilter: "blur(3px)",
          }}
        >
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <TextInput
              //withAsterisk
              label={
                <Text color='gray.2' weight={700}>
                  姓名
                </Text>
              }
              placeholder='请填写你的姓名或昵称'
              {...form.getInputProps("username")}
            />
            <TextInput
              //withAsterisk
              label={
                <Text color='gray.2' weight={700}>
                  验证码
                </Text>
              }
              placeholder='请填写验证码'
              mt='sm'
              {...form.getInputProps("password")}
            />
            <Center mt='3rem'>
              <Button
                //fullWidth
                type='submit'
                variant='gradient'
                gradient={{ from: "teal", to: "lime", deg: 105 }}
              >
                <Text size='md'>{isSubmitting ? "开启中..." : "开启聊天"}</Text>
              </Button>
            </Center>
          </form>
        </Box>

        <Text mb='1rem' color='white'>
          Powered by
          <a
            href='mailto:ruihua.niu@outlook.com'
            style={{ color: "white", margin: "0 5px" }}
          >
            Ruihua
          </a>
          with ❤️
        </Text>
      </Box>
    </Box>
  );
}

export default Login;
